<div class="bc-audio-settings js-menu-audio-settings">
  <button class="header-menu-link header-button-box" (click)="changeStatus()">
    <svg-icon icon="{{ getIconByStatus() }}"></svg-icon>
  </button>
</div>
